function createChatConfig(snippetId) {
  const styles = [
    'styles',
    {
      iconType: 'CHAT',
      openChat: { color: '#ffffff', backgroundColor: '#004b8c' },
      closeChat: { color: '#ffffff', backgroundColor: '#004b8c' }
    }
  ];

  const snippet = ['snippetId', snippetId];

  const supportedMessages = [
    'supportedMessagingContentTypes',
    [
      'text/plain',
      'application/vnd.amazonaws.connect.message.interactive',
      'application/vnd.amazonaws.connect.message.interactive.response'
    ]
  ];

  const customizationObject = [
    'customizationObject',
    {
      transcript: {
        hideDisplayNames: false,
        eventNames: {
          customer: 'Aprendiz',
          agent: 'Webchat Agent',
          supervisor: 'Webchat Supervisor'
        },
        eventMessages: {
          participantJoined: 'Aprendiz entrou no chat',
          participantDisconnect: 'Aprendiz foi desconectado',
          participantLeft: 'Aprendiz saiu do chat',
          participantIdle: 'Aprendiz, você está aí?',
          participantReturned: '',
          chatEnded: 'Chat encerrado'
        }
      },
      composer: {
        disableEmojiPicker: true,
        disableCustomerAttachments: true
      }
    }
  ];

  const initiateChatUserProps = ['initiateChat', { name: 'Aprendiz' }];

  window.amazon_connect = {
    ac: [
      styles,
      snippet,
      supportedMessages,
      customizationObject,
      initiateChatUserProps
    ]
  };
}

function initAmazonConnect(config) {
  const snippetId = config?.chatWidget?.snippetId;
  const chatInterfaceId = config?.chatWidget?.interfaceId;
  const chatScriptUrl = config?.chatWidget?.interfaceScriptUrl;

  if (!snippetId || !chatInterfaceId || !chatScriptUrl) {
    console.error('Missing environment variables to initialize chat widget.');
    return;
  }

  const chatWidget = document.createElement('script');

  chatWidget.src = chatScriptUrl;
  chatWidget.id = chatInterfaceId;
  chatWidget.async = 1;

  const head = document.getElementsByTagName('head')[0];

  head.appendChild(chatWidget);

  createChatConfig(snippetId);
}

function removeChatWidget() {
  const chatWidgetElement = document.getElementById(
    'amazon-connect-chat-widget'
  );

  chatWidgetElement?.remove();

  window.amazon_connect = undefined;
}

export default ({ app, env, store }) => {
  app.router.afterEach((to) => {
    const allowedPaths = ['home', 'view-id'];
    const hasWidget = !!window.amazon_connect;

    if (allowedPaths.includes(to.name) && !hasWidget) {
      initAmazonConnect(env.config);
      return;
    }

    if (!allowedPaths.includes(to.name)) {
      removeChatWidget();
    }
    // store
    //   .dispatch('user/check', { toChat: to.name })
    //   .then(() => {
    //     const allowedPaths = ['home', 'view-id'];
    //     const hasWidget = !!window.amazon_connect;
    //
    //     if (allowedPaths.includes(to.name) && !hasWidget) {
    //       initAmazonConnect(env.config);
    //       return;
    //     }
    //
    //     if (!allowedPaths.includes(to.name)) {
    //       removeChatWidget();
    //     }
    //   })
    //   .catch(() => removeChatWidget());
  });
};
